export default __webpack_public_path__ + "static/media/back-arrow.d5f252cd.svg";